import React, { useEffect } from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import PagedSearchResultsContainer from 'redux/containers/pages/search/PagedSearchResultsContainer'
import NotFound from 'components/NotFound'

const PagedSearch = ({ response, setSearchResultsLoaded, searchPhrase, ...props }) => (
  <ResponseConsumer
    response={response}
    skeleton='search-results'
    content={() => <PagedSearchResultsContainer {...{ response, ...props }} />}
    notfoundComponent={() => <NotFoundComponent {...{ searchPhrase, setSearchResultsLoaded }} />}
  />
)

const NotFoundComponent = ({ searchPhrase, setSearchResultsLoaded }) => {
  useEffect(() => {
    setSearchResultsLoaded(true)
    return () => setSearchResultsLoaded(false)
  }, [])

  const message = !searchPhrase ? 'Please enter a search phrase' : 'Not found'

  return <NotFound {...{ message }} />
}
export default PagedSearch
